<div class="paginator">
    <button id="prev" (click)="jumpToPage(activePage - 1)" [disabled]="activePage === 0" mat-flat-button disableRipple>
        <span class="material-icons">
            chevron_left
        </span>
    </button>
    <ul class="pages">
        <li class="page-btn" *ngFor="let number of pages; let idx = index">
            <a [class.active]="idx === activePage" (click)="jumpToPage(idx)" mat-flat-button disableRipple>{{idx +
                1}}</a>
        </li>
    </ul>
    <button id="next" (click)="jumpToPage(activePage + 1)" [disabled]="activePage === pages?.length - 1" mat-flat-button disableRipple>
        <span class="material-icons">
            chevron_right
        </span>
    </button>
</div>